import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { QuoteMarkAsAcceptedPage } from 'src/app/modals/quote-mark-as-accepted/quote-mark-as-accepted.page';

const routes: Routes = [
    {
        path: '',
        component: QuoteMarkAsAcceptedPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        FontAwesomeModule,
        RouterModule.forChild(routes)
    ],
    declarations: [QuoteMarkAsAcceptedPage]
})

export class QuoteMarkAsAcceptedPageModule { }
